import { getAnalyticsPath } from './getAnalyticsPath';

const inject = () => {
  return new Promise((resolve, reject) => {
    try {
      const script = document.createElement('script');
      script.src = getAnalyticsPath();
      script.async = true;
      document.body.appendChild(script);
      resolve('Analytics: added');
    } catch (error) {
      reject(`Analytics: ${error}`);
    }
  });
};

export const Analytics = {
  inject,
};
